import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { ColumnFiltersState } from "@tanstack/react-table";
import { Axios } from "api/axios";

const API_URL = process.env.REACT_APP_BASE_URL;
const TOKEN = "a94c7ac0083ae190f0fe61143a7547799b5334c4";

const headers = {
  Authorization: `Token ${TOKEN}`,
  "Content-Type": "application/json",
};

// export const fetchCategories = createAsyncThunk(
//   "category/fetchCategories",
//   async ({
//     page,
//     pageSize,
//     sort,
//     order,
//     search,
//     filters,
//   }: {
//     page: number;
//     pageSize: number;
//     search?: string;
//     sort?: string;
//     order?: "asc" | "desc" | "";
//     filters?: ColumnFiltersState;
//   }) => {
//     const params = new URLSearchParams();
//     params.append("page", page.toString());
//     params.append("page_size", pageSize.toString());
//     if (search) params.append("search", search);
//     if (sort) {
//       const orderingValue = order === "desc" ? `-${sort}` : sort;
//       params.append("ordering", orderingValue);
//     }

//     if (filters && filters.length > 0) {
//       // params.append("filters", JSON.stringify(filters));
//     }
//     const response: any = await Axios.get(`/category/?${params.toString()}`);

//     return {
//       data: response.data.data || [],
//       rowCount: response.data.count || 0,
//     };
//   }
// );

export const fethConfigAttributes = createAsyncThunk(
  "brands/fethConfigAttributes",
  async ({
    page,
    pageSize,
    sort,
    order,
    search,
    filters,
    attribute_id,
  }: {
    page: number;
    pageSize: number;
    search?: string;
    sort?: string;
    order?: "asc" | "desc" | "";
    filters?: any;
    attribute_id: any
  }) => {
    try {
      const params = new URLSearchParams();
      params.append("page", page.toString());
      params.append("page_size", pageSize.toString());
      if (search) params.append("search", search);
      if (sort) {
        const orderingValue = order === "desc" ? `-${sort}` : sort;
        params.append("ordering", orderingValue);
      }

      if (filters && filters.length > 0) {
        filters.forEach(
          ({
            filterField,
            filterValue,
          }: {
            filterField: string;
            filterValue: any;
          }) => {
            if (!filterField || filterValue === undefined || filterValue === null) return;

            // If filterValue is an object (like from_date/to_date)
            if (typeof filterValue === "object" && filterValue !== null) {
              if (filterValue.from_date)
                params.append(`${filterField}_date_from`, filterValue.from_date);
              if (filterValue.to_date)
                params.append(`${filterField}_date_to`, filterValue.to_date);
            } else {
              // Primitive value
              params.append(filterField, String(filterValue));
            }
          }
        );
      }

      let url = `api/manage-values/list/?attribute=${attribute_id}`;
      url += `&page=${page}&page_size=${pageSize}`;

      const response: any = await Axios.get(`api/manage-values/list/?attribute=${attribute_id}&${params.toString()}`);
      // const response: any = await Axios.get(url);
      return {
        data: response.data.data || [],
        rowCount: response.data.count || 0,
      };
    } catch (error: any) {
      console.error(
        "fetchBrandsAttributes error:",
        error.response?.data || error.message
      );
      throw new Error("Failed to fetch attributes");
    }
  }
);


export const fetchConfigById = createAsyncThunk(
  "config_attributes/fetchConfigById",
  async (id: string, { rejectWithValue }) => {
    try {
      const response: any = await Axios.put(`api/attributes/brand/edit/${id}/`);
      return response.data.data;
    } catch (err: any) {
      return rejectWithValue(
        err.response?.data || "Failed to fetch category by ID"
      );
    }
  }
);

export const fetchConfigAttributesByDropDown = createAsyncThunk(
  "config_attributes/fetchConfigAttributesByDropDown",
  async (_, { rejectWithValue }) => {
    try {
      const response = await Axios.get(`/category/dropdown/`);
      return response.data;
    } catch (err: any) {
      return rejectWithValue(
        err.response?.data || "Failed to fetch Category list"
      );
    }
  }
);

export const updateConfigAttributes = createAsyncThunk(
  "config_attributes/updateConfigAttributes",
  async (
    gpData: { id: string; payload: { attribute: string; value: string } },
    { rejectWithValue }
  ) => {
    try {
      const response: any = await Axios.put(
        `api/manage-values/edit/${gpData.id}/`,
        gpData.payload
      );
      return response.data;
    } catch (err: any) {
      return rejectWithValue(err.response?.data || "Failed to update attribute");
    }
  }
);





export const updateStatusInConfigAttributes = createAsyncThunk(
  "config_attributes/updateStatusInConfigAttributes",
  async (categoryData: any, { rejectWithValue }) => {
    try {
      const payload = { is_active: categoryData.is_active };
      const response: any = await Axios.patch(
        `api/attributes/brand/edit/${categoryData.id}/`,
        payload
      );
      return response.data.data;
    } catch (err: any) {
      return rejectWithValue(
        err.response?.data || "Failed to update status in category"
      );
    }
  }
);
// slices/attributes/thunk.ts
export const addConfigAttributes = createAsyncThunk(
  "attributes/addConfigAttributes",
  async (payload: { attribute: string; value: string }, { rejectWithValue }) => {
    try {
      const response: any = await Axios.post(
        "api/manage-values/create/",
        payload
      );
      return response;
    } catch (err: any) {
      return rejectWithValue(err.response?.data || "Failed to add attribute values");
    }
  }
);



export const deleteGp = createAsyncThunk(
  "category/delete",
  async (id: number, { rejectWithValue }) => {
    try {
      await Axios.delete(`/category/${id}/`);
      return id;
    } catch (err: any) {
      return rejectWithValue(err.response?.data?.message || err.message);
    }
  }
);

// export const exportCategoryCSV = async () => {
//   const response = await Axios.get("/category/?export=csv", {
//     responseType: "blob",
//   });

//   return {
//     blob: response.data,
//     filename:
//       response.headers["content-disposition"]
//         ?.split("filename=")[1]
//         ?.replace(/"/g, "") || "category.csv",
//   };
// };
export const exportCategoryCSV = async ({
  search,
  filters,
}: {
  search?: string;
  filters?: any;
}) => {
  const params = new URLSearchParams();

  params.append("export", "excel");

  if (search) params.append("search", search);

  if (filters && filters.length > 0) {
    filters.forEach(
      ({
        filterField,
        filterValue,
      }: {
        filterField: string;
        filterValue: any;
      }) => {
        if (filterField && filterValue !== undefined && filterValue !== null) {
          if (typeof filterValue === "object" && filterValue !== null) {
            Object.entries(filterValue).forEach(([key, value]) => {
              if (value !== undefined && value !== null && value !== "") {
                params.append(key, String(value));
              }
              if (
                (filterValue.from_date || filterValue.to_date) &&
                (filterField === "created_at" || filterField === "updated_at")
              ) {
                if (filterField === "created_at") {
                  filterField = "created";
                } else {
                  filterField = "updated";
                }
                params.append("filter_by", filterField);
              }
            });
          } else {
            params.append(filterField, filterValue);
          }
        }
      }
    );
  }

  const response = await Axios.get(`/category/?${params.toString()}`, {
    responseType: "blob",
  });

  return {
    blob: response.data,
    filename:
      response.headers["content-disposition"]
        ?.split("filename=")[1]
        ?.replace(/"/g, "") || "category.csv",
  };
};
